import Axios from 'axios';

import { DataResponse } from '../models';
import { DiscourseSsoParam } from '../models/discourseSsoParam';

export const sso = async (input: Pick<DiscourseSsoParam, 'sso' | 'sig'>) => (await Axios.post<DataResponse<DiscourseSsoParam>>('/v1/auth/discourse-sso', input)).data.data;
